
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="区域选择实例方法" fileName="range-selection-instance-methods.md" />
        <demo-block>
        <div><p>1、通过实例方法<code>setAllCellSelection()</code>设置单元格全选<br>2、通过实例方法<code>setRangeCellSelection({ startRowKey,startColKey,endRowKey,endColKey,isScrollToStartCell })</code>设置区域单元格选中<br></p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;setAllCellSelection()&quot;&gt;单元格全选&lt;/button&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;setRangeCellSelection()&quot;&gt;区域选择&lt;/button&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;ve-table
            ref=&quot;tableRef&quot;
            fixed-header
            :scroll-width=&quot;1600&quot;
            :max-height=&quot;380&quot;
            border-y
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            rowKeyFieldName=&quot;rowKey&quot;
            :virtual-scroll-option=&quot;virtualScrollOption&quot;
            :rowStyleOption=&quot;rowStyleOption&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                // start row index
                startRowIndex: 0,
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                    scrolling: this.scrolling,
                },
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                cellSelectionOption: {
                    // disble cell selection
                    enable: true,
                },
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;&quot;,
                        width: 15,
                        align: &quot;center&quot;,
                        fixed: &quot;left&quot;,
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return rowIndex + this.startRowIndex + 1;
                        },
                    },
                    {
                        field: &quot;col1&quot;,
                        key: &quot;col1&quot;,
                        title: &quot;col1&quot;,
                        width: 50,
                        fixed: &quot;left&quot;,
                    },
                    {
                        title: &quot;col2-col3&quot;,
                        fixed: &quot;left&quot;,
                        children: [
                            {
                                field: &quot;col2&quot;,
                                key: &quot;col2&quot;,
                                title: &quot;col2&quot;,
                                width: 50,
                            },
                            {
                                field: &quot;col3&quot;,
                                key: &quot;col3&quot;,
                                title: &quot;col3&quot;,
                                width: 50,
                            },
                        ],
                    },
                    {
                        title: &quot;col4-col5-col6&quot;,
                        children: [
                            {
                                title: &quot;col4-col5&quot;,
                                children: [
                                    {
                                        field: &quot;col4&quot;,
                                        key: &quot;col4&quot;,
                                        title: &quot;col4&quot;,
                                        width: 130,
                                    },
                                    {
                                        field: &quot;col5&quot;,
                                        key: &quot;col5&quot;,
                                        title: &quot;col5&quot;,
                                        width: 140,
                                    },
                                ],
                            },
                            {
                                title: &quot;col6&quot;,
                                field: &quot;col6&quot;,
                                key: &quot;col6&quot;,
                                width: 140,
                            },
                        ],
                    },
                    {
                        title: &quot;col7&quot;,
                        fixed: &quot;right&quot;,
                        children: [
                            {
                                title: &quot;col7-1&quot;,
                                field: &quot;col7&quot;,
                                key: &quot;col7&quot;,
                                width: 50,
                            },
                        ],
                    },
                    {
                        field: &quot;col8&quot;,
                        key: &quot;col8&quot;,
                        title: &quot;col8&quot;,
                        width: 50,
                        fixed: &quot;right&quot;,
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            // set all selection
            setAllCellSelection() {
                this.$refs[&quot;tableRef&quot;].setAllCellSelection();
            },
            // set range cell selection
            setRangeCellSelection() {
                this.$refs[&quot;tableRef&quot;].setRangeCellSelection({
                    startRowKey: 30,
                    startColKey: &quot;col2&quot;,
                    endRowKey: 32,
                    endColKey: &quot;col4&quot;,
                    isScrollToStartCell: true,
                });
            },
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 50; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
            // virtual scrolling
            scrolling({ startRowIndex }) {
                this.startRowIndex = startRowIndex;
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.setAllCellSelection()}}},[_vm._v("单元格全选")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.setRangeCellSelection()}}},[_vm._v("区域选择")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{ref:"tableRef",attrs:{"fixed-header":"","scroll-width":1600,"max-height":380,"border-y":"","columns":_vm.columns,"table-data":_vm.tableData,"rowKeyFieldName":"rowKey","virtual-scroll-option":_vm.virtualScrollOption,"rowStyleOption":_vm.rowStyleOption}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                // start row index
                startRowIndex: 0,
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                    scrolling: this.scrolling,
                },
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                cellSelectionOption: {
                    // disble cell selection
                    enable: true,
                },
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "",
                        width: 15,
                        align: "center",
                        fixed: "left",
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return rowIndex + this.startRowIndex + 1;
                        },
                    },
                    {
                        field: "col1",
                        key: "col1",
                        title: "col1",
                        width: 50,
                        fixed: "left",
                    },
                    {
                        title: "col2-col3",
                        fixed: "left",
                        children: [
                            {
                                field: "col2",
                                key: "col2",
                                title: "col2",
                                width: 50,
                            },
                            {
                                field: "col3",
                                key: "col3",
                                title: "col3",
                                width: 50,
                            },
                        ],
                    },
                    {
                        title: "col4-col5-col6",
                        children: [
                            {
                                title: "col4-col5",
                                children: [
                                    {
                                        field: "col4",
                                        key: "col4",
                                        title: "col4",
                                        width: 130,
                                    },
                                    {
                                        field: "col5",
                                        key: "col5",
                                        title: "col5",
                                        width: 140,
                                    },
                                ],
                            },
                            {
                                title: "col6",
                                field: "col6",
                                key: "col6",
                                width: 140,
                            },
                        ],
                    },
                    {
                        title: "col7",
                        fixed: "right",
                        children: [
                            {
                                title: "col7-1",
                                field: "col7",
                                key: "col7",
                                width: 50,
                            },
                        ],
                    },
                    {
                        field: "col8",
                        key: "col8",
                        title: "col8",
                        width: 50,
                        fixed: "right",
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            // set all selection
            setAllCellSelection() {
                this.$refs["tableRef"].setAllCellSelection();
            },
            // set range cell selection
            setRangeCellSelection() {
                this.$refs["tableRef"].setRangeCellSelection({
                    startRowKey: 30,
                    startColKey: "col2",
                    endRowKey: 32,
                    endColKey: "col4",
                    isScrollToStartCell: true,
                });
            },
            initTableData() {
                let data = [];
                for (let i = 0; i < 50; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
            // virtual scrolling
            scrolling({ startRowIndex }) {
                this.startRowIndex = startRowIndex;
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  